/**
 * Wide enough for the 15ch name floor below plus everything sharing its row, so the two can't drift
 * apart: 86px nav buttons + gaps, 48px select padding/arrow/borders, 80px flag badge, 8px gap, 2px
 * rounding. font-size is pinned so this ch (resolved on .container) matches the label's — that's a
 * MUI Typography body1 at 1rem, which the shared .dropdown's 14px never reaches. Nothing here renders
 * text at the inherited size; .label and .dropdown both set their own.
 */
.studentLabelWrapper {
	font-size: 1rem;
	--selector-container-width: calc(15ch + 224px);
}

/**
 * Never squeeze the name below 15 characters; OverflowText's ellipsis and tooltip handle the rest.
 * Replaces the shared .valueLabel rather than stacking on it — that class turns nowrap/ellipsis off
 * entirely below 768px, at exactly the widths this is meant to govern.
 */
.studentValueLabel {
	flex: 1;
	min-width: 15ch;
}

/**
 * Read-only only. The name is an OverflowText, i.e. a MUI Typography that sets its own weight, so
 * .staticValue's never reaches it — the override has to name both classes to outweigh it.
 */
.studentStaticValue {
	margin: 2px 0;
}

.studentStaticValue .studentValueLabel:global(.MuiTypography-root) {
	font-weight: 600;
}

/**
 * The control was clamped below the width it asked for, so 15 characters no longer fit on one line —
 * drop the floor and wrap instead, keeping all 15 readable. Threshold is --selector-container-width's
 * expression minus 1px so the two stay locked together. .MuiTypography-root outweighs the
 * `white-space: nowrap` OverflowText applies via sx.
 */
@container selectorDropdown (max-width: calc(15ch + 223px)) {
	.studentValueLabel:global(.MuiTypography-root) {
		min-width: 0;
		white-space: normal;
		overflow: visible;
		text-overflow: clip;
		overflow-wrap: anywhere;
	}

	/* The shared rule pins this to a single row. */
	.studentDropdown {
		height: auto !important;
		min-height: 36px;
	}

	/* Same allowance for the read-only box, so both wrap at the same threshold. */
	.studentStaticValue {
		height: auto;
		min-height: 36px;
		padding-top: 6px;
		padding-bottom: 6px;
	}
}

.navButton {
	width: 35px;
	height: 35px;
	min-width: 35px;
	flex-shrink: 0;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border: 1px solid #e0e0e0;
	border-radius: 0.7rem;
	box-sizing: border-box;
	cursor: pointer;
}

.navButton:hover {
	background-color: #f9f9f9;
}

.navButton:active {
	background-color: #f2eff7;
}

.navButton:focus-visible {
	outline: 2px solid #0b6f85;
	outline-offset: 2px;
}

.navIcon {
	width: 8px;
	height: 14px;
}

.navIconBack {
	transform: rotate(180deg);
}
